/**
 * Kanał logów bramki kartowej (`Surveillance` w swaggerze `Cards ExternalGateway`).
 *
 * ⚠️ JEDNA stała pod DWOMA kluczami (`c2p.log`, `cards.log`) - świadomie, bo to ten sam endpoint
 * dla dwóch przepływów, a karty zbierają z niego zdarzenia obu. Rozpisanie łańcucha dwa razy
 * pozwoliłoby im się rozjechać przy zmianie adresu.
 *
 * ⚠️ Prefiks to `/external/maintenance/`, choć swagger bramki publikuje tę operację jako
 * `/api/surveillance/log` pod `/external/gateway/`. Adres poniżej jest tym, który DZIAŁA na
 * produkcji (Click to Pay wysyła tu logi od dawna) - nie „poprawiaj" go do postaci ze swaggera bez
 * przejazdu.
 * @type {string}
 */
const SURVEILLANCE_LOG = '/external/maintenance/api/surveillance/log'

export const ENDPOINTS = {
  start: '/front-api/trx-api/www/start',
  continue: '/front-api/trx-api/www/continue',
  visadata: '/front-api/trx-api/www/visa-mobile/get-transaction-data',
  wait: {
    getData: '/front-api/trx-api/www/wtn-wait/get-data',
  },
  regulationsApprovalStart: '/front-api/trx-api/www/regulations-approval/start',
  languageData: '/front-api/trx-api/www/language-data',
  confirmation: '/front-api/trx-api/www/confirmation',
  result: '/front-api/trx-api/www/result',
  error: '/front-api/trx-api/www/error',
  reject: '/front-api/trx-api/www/reject',
  updatePayway: '/front-api/trx-api/www/update-payway',
  getPdf: '/front-api/trx-api/www/pdf',
  secureBack: '/front-api/trx-api/www/secure-back',
  walletData: '/front-api/trx-api/www/google-pay/configuration',
  session: {
    getRemainingTime: '/front-api/trx-api/www/session/get-remaining-time',
    refresh: '/front-api/trx-api/www/session/refresh',
    reject: '/front-api/trx-api/www/session/reject',
  },
  cards: {
    browser: {
      transactionStatus: '/external/gateway/api/browser/transaction-status',
      // Kanał zapisu decyzji użytkownika na etapie `DCC_FALLBACK` (PEP-806) i odmowy gSPA (PEP-800).
      // ⚠️ Ścieżka JEST w swaggerze bramki od odczytu 21.09.2026 (`transactionUpdate`, tag
      // `Browser`) - a jej payload zgadza się z tym, co wysyłamy. Kontrakt WARTOŚCI pól stanu
      // pochodzi dalej z diagramów `FlowType BROWSER`: swagger opisuje `dccState` i `gspaState`
      // jako zwykły `string`, bez enuma.
      // → `doc/robocze/pep-806-dcc-fallback-plan.md` §2.2, `doc/dokumentacja/karty.md`
      transactionUpdate: '/external/gateway/api/browser/transaction-update',
    },
    // Kanał logów ścieżki kartowej (PEP-800) - patrz `SURVEILLANCE_LOG` wyżej.
    log: SURVEILLANCE_LOG,
    visaMobile: {
      cancel: '/external/gateway/api/visa-mobile/cancel',
    },
    applePay: {
      session: '/external/gateway/api/applepay/session',
    },
  },
  ads: {
    getBannersList: '/ads/get_service_banner/',
    sendBannerViewConfirmation: '/ads/confirm_service_banner/',
  },
  synchub: {
    cookieLink: '/api/v1/cookie/link',
  },
  c2p: {
    log: SURVEILLANCE_LOG,
  },
  payerPaywall: {
    update: '/front-api/trx-api/www/vas-paywall-service/update',
    getFirmData: '/front-api/trx-api/www/vas-paywall-service/firm-data',
    getHistory: '/front-api/trx-api/www/vas-paywall-service/transaction-history',
  },
}
